'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var varint = require('varint');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var varint__namespace = /*#__PURE__*/_interopNamespace(varint);

function varintEncoder(buf) {
  var out = new Uint8Array(buf.reduce(function (acc, curr) {
    return acc + varint__namespace.default.encodingLength(curr);
  }, 0));
  var offset = 0;

  var _iterator = _createForOfIteratorHelper(buf),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var num = _step.value;
      out = varint__namespace.encode(num, out, offset);
      offset += varint__namespace.default.encodingLength(num);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return out;
}

module.exports = varintEncoder;